import { Plugin, PluginKey } from 'prosemirror-state';
import { EventChannel } from '../../event';
var pluginKey = new PluginKey('lifecycle');
var emitLifeCycleEvent = function (view, prevState, emitter) {
    var state = view.state;
    if (!prevState.doc.eq(state.doc)) {
        /**
         * TODO
         * since the timing of updating the DOM by libraries such as react and vue is not synchronized.
         * it will make `getHTML()` return lagging content  if trigger the `text-change` event synchronized
         */
        setTimeout(function () { return emitter.emit(EventChannel.LocalEvent.TEXT_CHANGED); });
    }
    if (!prevState.selection.eq(state.selection)) {
        emitter.emit(EventChannel.LocalEvent.SELECTION_CHANGED);
    }
};
var createLifeCyclePlugin = function (adapter) {
    return new Plugin({
        key: pluginKey,
        view: function () { return ({
            update: function (view, prevState) {
                return emitLifeCycleEvent(view, prevState, adapter.configurator.emitter);
            },
        }); },
    });
};
export { createLifeCyclePlugin, emitLifeCycleEvent };
//# sourceMappingURL=lifecycle-plugin.js.map